import { Typography } from "@spz/ui/components/typography";
import type { AmountCellProps } from "../types";

/**
 * Formats a number to a currency string based on locale and currency code.
 * @param amount - The amount to format.
 * @param currency - The currency code to use for formatting (default is 'USD').
 * @param minorUnit - The number of minor units (e.g., cents) for the currency.
 * @returns The formatted currency string.
 */
export const formatCurrency = ({
  amount,
  minorUnit,
  currency,
}: {
  amount: number;
  minorUnit: number;
  currency: string;
}): string => {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
  }).format(amount / 10 ** minorUnit);
};

export const AmountCell: React.FC<AmountCellProps> = ({
  value,
  currency,
  className,
}) => {
  return (
    <Typography variant="body" className={className}>
      {formatCurrency({
        amount: value,
        minorUnit: currency.minorUnit,
        currency: currency.alphabeticalCode,
      })}
    </Typography>
  );
};
